import packageJson from './package.json';

export const { version } = packageJson;
export * from './src/controls';
export { CheckboxGroup } from './src/checkbox-group';
export type { ICheckboxGroupProps, ICheckboxGroupState } from './src/checkbox-group';
export { RadioGroup } from './src/radio-group';
export type { IRadioGroupProps, IRadioGroupState } from './src/radio-group';
export * from './src/types';
